module.exports = __webpack_public_path__ + "static/img/xi_5.a547fec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xi_5.jpg
// module id = 5uy6
// module chunks = 1